import { MLM, MsTracking, NOT_SET, TrackingParameter, createTealiumTracking } from '@sunrise/tracking'

import { DecoratedEstate } from '../../ts/mapper/decoratedItemEstate.interface'
import { ActionIds, MLMData } from '../../ts/tracking/mlmActionIds.enum'
import { staticMlmTrackingData } from '../../ts/tracking/mlmStaticTrackingData'
import { TealiumTrackingIds } from '../../ts/tracking/tealiumTrackingIds.enum'
import { getCompanyName, getLikedAction, getPositionAsString, getTypePaid } from '../../ts/utils/trackingUtils'

export function getTealiumTrackingData(): TrackingParameter {
    return {
        mslayer_element_data_id: TealiumTrackingIds.BOOKMARK_LIKE_AND_REMOVE_AND_REVERT_CLICK,
        mslayer_element_type_text: 'Merkliste',
        mslayer_element_count: NOT_SET,
        mslayer_element_body_type: 'list',
        mslayer_affiliate_id: NOT_SET,
        mslayer_element_detail_start_date: NOT_SET,
    }
}

export function buildTealiumTrackingData(
    item: DecoratedEstate,
    liked: boolean,
    partOfRecommender: boolean,
    isExposeeOnline: boolean,
): MsTracking[] {
    return [
        createTealiumTracking({
            ...getTealiumTrackingData(),
            mslayer_element_company_name: getCompanyName(item.ownInventory),
            mslayer_element_id: item.exposeeId,
            mslayer_element_position: item.position ? getPositionAsString(item.position) : NOT_SET,
            mslayer_element_text: getLikedAction(liked),
            mslayer_element_variant: partOfRecommender ? getRecommenderVariant(isExposeeOnline) : 'default',
        }),
    ]
}

export function getMlmTrackingData(): MLM.TrackingData {
    return {
        ...staticMlmTrackingData,
        page: MLMData.DEFAULT_PAGE as number,
        pageUrl: document.URL,
        actionId: ActionIds.BOOKMARK_LIKE_CLICK,
        componentId: '',
        items: [],
    }
}

export function buildMlmTrackingData(wrapperItem: DecoratedEstate, componentId: string, page = 1): MLM.TrackingData {
    return {
        ...getMlmTrackingData(),
        page: page,
        componentId,
        items: [
            {
                id: wrapperItem.exposeeId,
                type: getCompanyName(wrapperItem.ownInventory),
                typePaid: getTypePaid(wrapperItem.ownInventory),
                typePosition: wrapperItem.position ? wrapperItem.position : 1,
            },
        ],
    }
}

function getRecommenderVariant(isExposeeOnline: boolean) {
    return isExposeeOnline ? 'recommender_active' : 'recommender_inactive'
}
